export default "__VITE_PUBLIC_ASSET__b5b6b069__"